module.exports = __webpack_public_path__ + "static/media/ReTrue-Logo.5b4b01b8.png";